/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Route, Routes} from 'react-router-dom'
import IssueAreasLayout from './IssueAreasLayout'

const IssueAreasPage: React.FC<{subject: string}> = ({subject}) => (
  <Routes>
    <Route element={<IssueAreasLayout subject={subject} />}>
      <Route index element={<IssueAreasLayout subject={subject} />} />
    </Route>
  </Routes>
)

export {IssueAreasPage}
